import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  margin: 30px 0;
  padding: 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #666;

  &:hover {
    background: #25D366;
    color: white;
    border-color: #25D366;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(37, 211, 102, 0.2);
  }

  .icon {
    margin-right: 6px;
    font-size: 12px;
  }
`;

const RelatedSearches = ({ searches = [], currentQuery }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!searches || searches.length === 0) {
    return null;
  }

  const handleSearchClick = (searchTerm) => {
    navigate(`/ads?q=${encodeURIComponent(searchTerm)}`);
  };

  return (
    <Container>
      <Title>
        <i className="fas fa-search" style={{ marginRight: '8px', color: '#999' }}></i>
        {t('relatedSearches') || 'Búsquedas Relacionadas'}
      </Title>
      <ChipsContainer>
        {searches.map((search, index) => {
          const searchTerm = typeof search === 'string' ? search : search.term || search.query;
          
          // Skip if it's the same as current query
          if (searchTerm.toLowerCase() === currentQuery?.toLowerCase()) {
            return null;
          }

          return (
            <Chip key={index} onClick={() => handleSearchClick(searchTerm)}>
              <span className="icon">🔍</span>
              <span>{searchTerm}</span>
            </Chip>
          );
        })}
      </ChipsContainer>
    </Container>
  );
};

export default RelatedSearches;
